import React from "react";
import { withTranslation } from "react-i18next";
import user from "../../assets/phone.svg"
import "./styles.css";

const index = ({ name, logo, onClick}) => {
  return (
      <div className="quick-link" onClick={onClick}>
        <p className="text-dark quic-name">{name}</p>
        <img src={require(`../../assets/${logo}.png`)} width="50px"/>
      </div>
  );
};

export default withTranslation()(index);
